import { createSelector } from 'src/universal/redux/utils';
import { getPageCardsData } from 'src/universal/redux/page';
import {
  getPznOfferList,
  hasPznDataArrived as getHasPznDataArrived
} from 'src/universal/redux/pznData';
import {
  isGCSMember,
  isLegacyGcsCardMember
} from 'src/universal/redux/cardMemberInfo';
import { getUpgradeCtaProps } from 'src/universal/utils/orchestraUtils';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import { getFormattedCtaLinks } from './utils';

const getCardListAsObject = createSelector([getPageCardsData], cardListData =>
  parseArrayToObject(cardListData.filter(card => !!card), 'shortName')
);

export const getUpgradeCta = createSelector(
  [
    getCardListAsObject,
    getPznOfferList,
    isGCSMember,
    isLegacyGcsCardMember,
    getHasPznDataArrived,
    (_, cardName) => cardName
  ],
  (cardList, pznOfferList, isGcsCm, isLegacyGcsCm, hasPznDataArrived, cardName) => {
    if (!hasPznDataArrived) return {};
    const card = cardList[cardName];
    const pznOffer = pznOfferList.find(({ shortName }) => shortName === cardName);
    const { upgradeBtn, needUpgradeCta, cmPznEventInfo } = getUpgradeCtaProps(
      card,
      pznOffer,
      isGcsCm || isLegacyGcsCm
    );

    return {
      upgradeBtn,
      needUpgradeCta,
      cmPznEventInfo
    };
  }
);

export const makeGetLinks = () =>
  createSelector(
    [
      getCardListAsObject,
      getPznOfferList,
      getHasPznDataArrived,
      (_, cardName) => cardName
    ],
    (cardList, pznOfferList, hasPznDataArrived, cardName) => {
      if (!hasPznDataArrived) return {};
      const card = cardList[cardName];
      const offer = pznOfferList.find(offer => offer.shortName === cardName);
      const links = getFormattedCtaLinks({
        originalLinks: card.links,
        pageEep: undefined,
        pznOffer: offer
      });
      return links;
    }
  );

export const makeGetCardData = () =>
  createSelector(
    [
      getCardListAsObject,
      getPznOfferList,
      getHasPznDataArrived,
      makeGetLinks(),
      (_, cardName) => cardName
    ],
    (cardList, pznOfferList, hasPznDataArrived, links, cardName) => {
      if (!hasPznDataArrived) return { pznArrived: false };
      const card = cardList[cardName];
      const offer = pznOfferList.find(offer => offer.shortName === cardName);
      return {
        ...card,
        pznOffer: offer,
        links,
        pznArrived: true
      };
    }
  );
